import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { CostCenter, PagedResponseCostCenter } from '../models/CostCenter';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class CostCenterService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getCostCenters():Observable<PagedResponseCostCenter>{
    const data =  this.http.get<PagedResponseCostCenter>(this.APIURL+'/CostCenter' + '?PageNumber=1&PageSize=1500');
    this.messageService.add('SavingsMeasure Service: fetched CostCenters');
    return data;
  }
  getCostCenterByShopId(shopId: number): Observable<PagedResponseCostCenter> {
    const data = this.http.get<PagedResponseCostCenter>(this.APIURL + '/CostCenter/GetCostCenterByShopId/' + shopId);
    this.messageService.add('SavingsMeasure Service: fetched CostCenters');
    return data;
  }
  getCostCenter(id: number): Observable<CostCenter> {
        const CostCenter =this.http.get<CostCenter>(this.APIURL+'/CostCenter/' + id);
    this.messageService.add(`CostCenter Service: fetched CostCenter with id=${id}`);
    return CostCenter;
  }
}